"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _KeyStore = require("crm_data/store/KeyStore");

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _TimelineConstants = require("crm_universal/timeline/TimelineConstants");

var _getIn = _interopRequireDefault(require("transmute/getIn"));

var _timelineItemComparator = require("crm_ui/timeline/helpers/timelineItemComparator");

var _ETypes = _interopRequireDefault(require("crm_universal/timeline/ETypes"));

var EMAIL_CLICK = _TimelineConstants.TRACKED_EVENT_TYPES.EMAIL_CLICK,
    EMAIL_OPEN = _TimelineConstants.TRACKED_EVENT_TYPES.EMAIL_OPEN;
var FUTURE_KEY = 'FUTURE';

function getId(timelineItem, searchText) {
  var appId = timelineItem.getIn(['eventData', 'applicationId']);
  var id = timelineItem.getIn(['eventData', 'sentBy', 'id']) || timelineItem.getIn(['engagement', 'id']) || timelineItem.getIn(['eventData', 'engagement', 'id']) || timelineItem.getIn(['eventData', 'id']) || timelineItem.get('id');
  var eventType = timelineItem.getIn(['engagement', 'type']) || timelineItem.getIn(['eventData', 'engagement', 'type']) || timelineItem.get('etype');
  var createdBy = timelineItem.getIn(['engagement', 'createdBy']) || timelineItem.getIn(['eventData', 'engagement', 'createdBy']);
  var teamId = timelineItem.getIn(['engagement', 'teamId']) || timelineItem.getIn(['eventData', 'engagement', 'teamId']);

  if (appId) {
    var integrationAppId = "integrations-app-" + appId;
    return (0, _immutable.Map)({
      id: "" + id,
      eventType: eventType,
      integrationAppId: integrationAppId
    });
  }

  return (0, _immutable.Map)({
    id: "" + id,
    eventType: eventType,
    createdBy: createdBy && "" + createdBy,
    teamId: createdBy && "" + teamId,
    searchText: searchText
  });
}

function getMonthTimestamp(timelineItem) {
  var timestamp = (0, _timelineItemComparator.getTimelineItemTimestamp)(timelineItem);
  return _I18n.default.moment.userTz(timestamp).endOf('month').valueOf();
}

function getTimelineItems(data) {
  if (data.sampleEvents) {
    return data.sampleEvents;
  }

  return data.get('events');
}

function isFutureTimelineItem(timelineItem) {
  var now = Date.now();
  var timestamp = (0, _timelineItemComparator.getTimelineItemTimestamp)(timelineItem);
  return timestamp > now;
}

function getMonthKey(timelineItem) {
  if (isFutureTimelineItem(timelineItem)) {
    return FUTURE_KEY;
  }

  return "" + getMonthTimestamp(timelineItem);
}

function getUpdatedEngagements(engagementsMap) {
  return engagementsMap.valueSeq().filter(function (engagement) {
    return engagement && engagement.size;
  });
}

function getSidekickEvents(timelineItem) {
  var type = timelineItem.getIn(['eventData', 'type']);
  var sources = timelineItem.getIn(['eventData', 'sources']);

  if (type === EMAIL_OPEN || type === EMAIL_CLICK) {
    return sources.reduce(function (map, source) {
      var timestamp = source.get('timestamp');
      var id = (0, _immutable.Map)({
        id: type + "-" + timestamp,
        eventType: _TimelineConstants.EVENT_SIDEKICK
      });
      var key = getMonthKey(timelineItem.set('timestamp', timestamp));
      return map.update(key, function () {
        var timelineItemSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Set)();
        return timelineItemSet.add(id);
      });
    }, (0, _immutable.Map)());
  }

  return null;
}

function shouldFilterOutMarketingEmail(timelineItem) {
  return timelineItem.getIn(['eventData', 'cosEmail']) && timelineItem.hasIn(['eventData', 'obsoletedBy']) || timelineItem.getIn(['eventData', 'appName']) === 'BatchTest';
}

var _default = (0, _KeyStore.defineKeyStore)({
  namespace: 'TIMELINE_MONTHS',
  idIsValid: function idIsValid(id) {
    return typeof id === 'string';
  }
}).defineResponseTo([_ActionTypes.ADD_SAMPLE_TIMELINE_ITEMS, _ActionTypes.FETCH_TIMELINE_ITEMS_SUCCESS, _ActionTypes.POLLING_FETCH_TIMELINE_ITEMS_SUCCESS], function (state, data) {
  var timelineItems = getTimelineItems(data);

  if (!timelineItems || !timelineItems.size) {
    return state;
  }

  timelineItems.forEach(function (timelineItem) {
    if (shouldFilterOutMarketingEmail(timelineItem)) {
      return;
    } // CRM-11854 - supress DEPRECATED_PAGEVIEW events


    if (timelineItem.get('etype') === _ETypes.default.eventPageView && !timelineItem.getIn(['eventData', 'firstActivities'])) {
      return;
    }

    if (timelineItem.get('etype') === _TimelineConstants.EVENT_SIDEKICK) {
      state = state.mergeDeep(getSidekickEvents(timelineItem));
    } else {
      var id = getId(timelineItem, (0, _getIn.default)(['originalPayload', 'searchText'], data));
      var key = getMonthKey(timelineItem);
      var oldKey = state.findKey(function (k) {
        return k.includes(id);
      });

      if (oldKey && oldKey !== key) {
        state = state.update(oldKey, function (timelineItemsSet) {
          return timelineItemsSet.delete(id);
        });
      }

      state = state.update(key, function () {
        var timelineItemsSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Set)();
        return timelineItemsSet.add(id);
      });
    }
  });
  return state;
}).defineResponseTo(_ActionTypes.DELETE_TIMELINE_ENGAGEMENT, function (state, _ref) {
  var engagement = _ref.engagement;
  var id = getId(engagement);
  var key = getMonthKey(engagement);
  state = state.update(key, function () {
    var timelineItemsSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Set)();
    return timelineItemsSet.delete(id);
  });
  return state;
}).defineResponseTo(_ActionTypes.ADD_ENGAGEMENT, function (state, _ref2) {
  var engagement = _ref2.engagement;
  var id = getId(engagement);
  var key = getMonthKey(engagement);
  state = state.update(key, function () {
    var timelineItemsSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Set)();
    return timelineItemsSet.add(id);
  });
  return state;
}).defineResponseTo(_ActionTypes.ENGAGEMENTS_UPDATED, function (state, engagementsMap) {
  if (!engagementsMap || !engagementsMap.size) {
    return state;
  }

  var updatedEngagements = getUpdatedEngagements(engagementsMap);
  updatedEngagements.forEach(function (engagement) {
    var id = getId(engagement);
    var key = getMonthKey(engagement);

    if (state.hasIn([key, id])) {
      return state;
    }

    var oldKey = state.findKey(function (k) {
      return k.includes(id);
    });

    if (!oldKey) {
      return state;
    }

    state = state.update(oldKey, function (timelineItemsSet) {
      return timelineItemsSet.delete(id);
    }).update(key, function () {
      var timelineItemsSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Set)();
      return timelineItemsSet.add(id);
    });
    return state;
  });
  return state;
}).defineResponseTo(_ActionTypes.NAVIGATE, function () {
  return (0, _immutable.Map)();
}).register();

exports.default = _default;
module.exports = exports.default;